class DocumentationPathWizardData {

    constructor() {

        this._PATH_WIZARD_SEQUENTIAL_NAV = 1;
        this._PATH_WIZARD_RESTRICTED_NAV = 2;

        this._navigationData = null;

    }

    getNavigationModes() {

        return {
            SEQUENTIAL_NAV: this._PATH_WIZARD_SEQUENTIAL_NAV,
            RESTRICTED_NAV: this._PATH_WIZARD_RESTRICTED_NAV
        }

    }

    getNavigationData() {
        return this._navigationData;
    };

    setNavigationData(pathData, currentIndex, currentBlocked, nextBlocked) {

        this._navigationData = {
            pathState: pathData.progressState.state,
            navMode: pathData.navigation_type,
            navModes: this.getNavigationModes(),
            totalContents: pathData.numberOfContents,
            currentIndex: currentIndex,
            isBlocked: currentBlocked,
            nextIsBlocked: nextBlocked,
            items: pathData.sections[0].items
        }

    };

}